import { CircleAlert, LoaderCircle, Pause, Play } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useVoicePreview } from "./VoicePreviewContext";

export function VoicePreviewButton({
  voiceId,
  voiceName,
  previewUrl,
}: {
  voiceId: string;
  voiceName: string;
  previewUrl: string | null;
}) {
  const preview = useVoicePreview();
  const isActive = preview.activeVoiceId === voiceId;
  const state = isActive ? preview.state : "idle";

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      disabled={!previewUrl || state === "loading"}
      aria-label={
        state === "playing"
          ? `Pause preview for ${voiceName}`
          : `Play preview for ${voiceName}`
      }
      title={
        previewUrl
          ? "Play a short sample (free)"
          : "No preview available for this voice"
      }
      onClick={() => previewUrl && preview.toggle(voiceId, previewUrl)}
    >
      {state === "loading" ? (
        <LoaderCircle className="size-4 animate-spin" />
      ) : state === "playing" ? (
        <Pause className="size-4" />
      ) : state === "error" ? (
        <CircleAlert className="size-4 text-destructive" />
      ) : (
        <Play className="size-4" />
      )}
    </Button>
  );
}
